import React, { useMemo } from "react"
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
} from "@tanstack/react-table"
import { FormGroup, Input, Label, Table } from "reactstrap"
import PropTypes from "prop-types"
import HandleError from "./HandleError"

function DataTable(props) {
  const {
    data,
    columns,
    rowSelection = [],
    onSelectionChange,
    isLoading,
    error,
  } = props

  const tableColumns = useMemo(() => {
    return [
      {
        accessorKey: "id",
        header: ({ table }) => {
          return (
            <FormGroup check className="font-size-16">
              <Label check>
                <Input
                  type="checkbox"
                  id="checkAll"
                  checked={table.getIsAllRowsSelected()}
                  indeterminate={table.getIsSomeRowsSelected()}
                  onChange={table.getToggleAllRowsSelectedHandler()}
                />
              </Label>
            </FormGroup>
          )
        },
        cell: ({ row }) => {
          return (
            <FormGroup check className="font-size-16">
              <Label check>
                <Input
                  type="checkbox"
                  id={`checked-${row.original.id}`}
                  checked={row.getIsSelected()}
                  disabled={!row.getCanSelect()}
                  onChange={row.getToggleSelectedHandler()}
                />
              </Label>
            </FormGroup>
          )
        },
      },
      ...columns,
    ]
  }, [])

  const table = useReactTable({
    columns: tableColumns,
    data,
    getCoreRowModel: getCoreRowModel(),
    getRowId: row => row.id,
    onRowSelectionChange: rowSelection => onSelectionChange(rowSelection),
    state: {
      rowSelection,
    },
  })

  const { getHeaderGroups, getRowModel } = table

  return (
    <div className={"table-responsive my-3"}>
      <Table className="table table-nowrap mb-0">
        <thead>
          {getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => {
                return (
                  <th key={header.id} colSpan={header.colSpan}>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {getRowModel().rows.map(row => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map(cell => {
                  return (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
      <HandleError isLoading={isLoading} error={error} isEmpty={!data.length} />
    </div>
  )
}
DataTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.any,
}
export default DataTable
